import React, { useState } from "react";
import { useSharedState } from "../../context/formsContext";
import "./numberInCircle.css";

const NumberInCircle = ({
  color,
  number,
  onClick,
  isGcse,
  liveCurrentQuizQuestions,
  currentCurriculumId,
  generateNumberCircles,
}) => {
  // const { liveCurrentQuizQuestions } = useSharedState();
  const [hover, setHover] = useState(false);

  if (color === "orange") {
    return (
      <div
        onClick={onClick}
        className={`circle-orange flex items-center justify-center`}
      >
        <p className="font-size">{number}</p>
      </div>
    );
  }

  if (color === "blue") {
    return (
      <div
        onClick={onClick}
        className={`circle-blue-gcse flex items-center justify-center`}
      >
        <p className="font-size">{number}</p>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      className={`${generateNumberCircles(
        hover
      )} flex items-center justify-center cursor-pointer`}
    >
      <p className="font-size">{number}</p>
    </div>
  );
};

export default NumberInCircle;
